<!--
  @component StatStripBlock — the at-a-glance account numbers.
  tier:      home block (kind: "stat-strip")
  purpose:   four glanceable tiles — projects, live, deploys today, health.
-->
<script lang="ts">
  import { useIdentityIO } from "../../accounts/IdentityIO.svelte";
  import { useProvenanceIO } from "../../../../global/io/nodes/deployment/ProvenanceIO.svelte";
  import { projectRollup, accountStats } from "../home-util.js";

  const identity = useIdentityIO();
  const provenance = useProvenanceIO();

  const stats = $derived.by(() => {
    const roll = projectRollup(provenance.events);
    return accountStats(identity.projects, provenance.events, roll);
  });
</script>

<div class="strip">
  <div class="stat">
    <span class="num">{stats.projects}</span>
    <span class="label">Projects</span>
  </div>
  <div class="stat">
    <span class="num">{stats.live}</span>
    <span class="label">Live</span>
  </div>
  <div class="stat">
    <span class="num">{stats.deploys24h}</span>
    <span class="label">Deploys · 24h</span>
  </div>
  <div class="stat" class:warn={stats.issues > 0}>
    <span class="num">{stats.issues === 0 ? "✓" : stats.issues}</span>
    <span class="label">{stats.issues === 0 ? "All healthy" : "Need attention"}</span>
  </div>
</div>

<style>
  .strip {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: var(--space-3);
  }
  .stat {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: var(--space-4) var(--space-4) var(--space-3);
    background: var(--glass-fill);
    border: 0.5px solid var(--border);
    border-radius: var(--radius-lg, 14px);
    font-family: var(--type-font);
  }
  .num {
    font-size: 28px; font-weight: 600; letter-spacing: -0.02em; line-height: 1;
    color: var(--text-primary); font-variant-numeric: tabular-nums;
  }
  .label {
    font-size: 11px; font-weight: 500; letter-spacing: 0.04em; text-transform: uppercase;
    color: var(--text-tertiary);
  }
  .stat.warn .num { color: var(--warning, #e6b450); }
  .stat.warn { border-color: color-mix(in oklab, var(--warning, #e6b450) 35%, var(--border)); }
  @media (max-width: 720px) { .strip { grid-template-columns: repeat(2, 1fr); } }
</style>
